module.exports = __webpack_public_path__ + "img/usdt.765ea4f1.svg";